import { render, staticRenderFns } from "./RegSemiProductPallet.vue?vue&type=template&id=01825b9c&"
import script from "./RegSemiProductPallet.vue?vue&type=script&lang=js&"
export * from "./RegSemiProductPallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports